module.exports = __webpack_public_path__ + "static/macquaire-logo-ca2f1dc79b9add0e2a622bf0f99d3c77.png";